<template>
  <div class="campaign-prize" v-loading="!loaded">
    <campaign-prize-dialog ref="campaignPrizeDialog"></campaign-prize-dialog>
    <div class="mb-x2" layout="layout" layout-align="space-between-center">
      <div layout="layout">
        <div class="mr-x1">
          <el-button class="el-button-mt" type="default" @click="onChangeBackEvent"
            ><i class="mdi mdi-arrow-left"></i>戻る</el-button
          >
        </div>
      </div>
      <div v-if="campaign.id" layout="row" layout-align="end-center">
        <div class="mr-x3">応募者数: {{ formatNumber(campaign.applicantsCount) }}</div>
        <div class="mr-x3">
          当選者数: {{ formatNumber(campaign.winnerCount) }}(残り{{
            formatNumber(campaign.maxWinnerCount - campaign.winnerCount)
          }})
        </div>
        <div class="mr-x3">回答者数: {{ formatNumber(campaign.responderCount) }}</div>
        <div>{{ lastProcessedData }}: {{ lastProcessedDatetime }}</div>
      </div>
    </div>
    <div v-if="isCampaignCollectionCompleted">
      <div class="mb-x2">
        <div class="message message-info">
          全応募データの最終集計が完了しました。<br />応募者一覧から当選者の選定および、当選メッセージを配信してください。
        </div>
      </div>
    </div>
    <div v-else-if="isCampaignFinalCollection">
      <div class="mb-x2">
        <div class="message message-info">
          現在、応募データの最終集計処理を行なっています。<br />{{
            collectCompletedAt
          }}ごろまでに全応募データが反映されます。応募件数により、反映が遅れる場合があります。
        </div>
      </div>
    </div>
    <template v-else-if="isRepostEntryCampaign">
      <div v-if="isRepostCampaignBeforeStart">
        <div class="mb-x2">
          <div class="message message-info">
            このキャンペーンは、{{
              campaignStartDatetime
            }}から開催されます。<br />キャンペーン開始後、応募収集URLを設定してください。設定されるまで応募は収集されません。<br />応募収集URLを設定すると、応募は30分間隔で収集されます。URLの設定時点から7日より前の応募は収集されないため、早めに設定してください。
          </div>
        </div>
      </div>
      <div v-else-if="isRepostCampaignBeforeCollect">
        <div class="mb-x2">
          <div class="message message-info">
            応募収集URLを設定すると、応募の収集を開始します。設定されるまで応募は収集されません。<br />応募は30分間隔で収集されます。URLの設定時点から7日より前の応募は収集されないため、早めに設定してください。
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="isCampaignBeforeStart">
        <div class="mb-x2">
          <div class="message message-info">
            このキャンペーンは、{{
              campaignStartDatetime
            }}から開催されます。<br />ポスト、メンション・返信は30分間隔で収集されます。
          </div>
        </div>
      </div>
      <div v-else-if="isCampaignBeforeCollect">
        <div class="mb-x2">
          <div class="message message-info">
            応募タイプがポストの場合、30分間隔で収集されます。<br />応募収集が開始されるまで、しばらくお待ちください。
          </div>
        </div>
      </div>
    </template>
    <el-card v-if="!error">
      <div class="mb-x3" layout="row" layout-align="space-between-center">
        <el-button
          type="primary"
          :disabled="isCampaignFinalCollection || isCampaignCollectionCompleted"
          @click="onChangeCampaignPrizeDialogEvent"
          ><i class="mdi mdi-plus"></i>応募グループの新規作成</el-button
        >
        <div class="header-right" layout="row">
          <el-button class="mr-x1" v-if="campaign.id" @click="onChangeTwitterPostEvent"
            ><i class="mdi mdi-format-list-bulleted"></i>応募履歴</el-button
          >
          <csv-download v-if="!error && prizes.length" :download="downloadCsv"></csv-download>
        </div>
      </div>
      <div class="message message-error" v-if="loaded && !prizes.length">
        キャンペーン開始日時までに応募グループを作成してください。<br />応募グループがない場合、データを取得できません。
      </div>
      <twitter-prize-table
        v-if="prizes.length"
        :prizes="prizes"
        :options="options"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
        :onChangeSortBy="onChangeSortBy"
      ></twitter-prize-table>
    </el-card>
    <el-card v-else>
      <div class="message message-error">
        データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import CsvDownload from '@/client/components/_atoms/csv_download'
import { CAMPAIGN_STATUS } from '@/client/constant'
import api from '@/client/core/api'
import util from '@/client/core/util'
import { isRepostEntryActionType } from '@/client/features/campaigns/utils/campaignUrlSettingTarget'
import {
  RepostCollectionAlertState,
  resolveRepostCollectionAlertState
} from '@/client/features/campaigns/utils/repostCollectionAlert'
import CampaignPrizeDialog from '@/client/features/twitter_campaign_prize/campaign_prize_dialog'
import TwitterPrizeTable from '@/client/features/twitter_campaign_prize/twitter_prize_table'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useCampaignStore } from '@/client/store/useCampaignStore'
import { useNavbarStore } from '@/client/store/useNavbarStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterCampaignPrizeStore } from '@/client/store/useTwitterCampaignPrizeStore'
import { isBeforeNttAaaSwitchover } from '@/common/utils'

export default defineComponent({
  components: {
    CsvDownload,
    TwitterPrizeTable,
    CampaignPrizeDialog
  },
  data: () => {
    return {
      isLeave: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroupId: state => state.currentGroup.id
    }),
    ...mapState(useCampaignStore, {
      lastQueryParams: state => state.lastQueryParams
    }),
    ...mapState(useTwitterCampaignPrizeStore, {
      prizes: state => state.prizes,
      error: state => state.error,
      params: state => state.params,
      loaded: state => state.firstLoaded,
      campaign: state => state.campaign ?? {},
      options: state => ({
        total: state.total,
        pagingNo: state.params.pagingNo,
        limitCount: state.params.limitCount,
        sortBy: state.params.sortBy
      })
    }),

    lastProcessedData() {
      if (['tweet', 'tweet_media'].includes(this.campaign.setting?.entryActionType)) {
        return 'ポスト取得日時'
      }
      return 'データ取得日時'
    },

    lastProcessedDatetime() {
      if (
        isBeforeNttAaaSwitchover() &&
        ['quote_tweet', 'retweet', 'retweet_and_quote_tweet', 'mention'].includes(
          this.campaign.setting?.entryActionType
        ) &&
        this.campaign.account.enterpriseToken
      ) {
        return 'リアルタイム反映'
      }

      if (!this.campaign.lastProcessedDatetime) {
        return '-'
      }

      return moment(this.campaign.lastProcessedDatetime).format('YYYY年MM月DD日 HH:mm')
    },

    campaignStartDatetime() {
      return moment(this.campaign.startDatetime).format('YYYY年MM月DD日 HH:mm')
    },

    collectCompletedAt() {
      // フォロワー取得バッチが深夜1時に実行されるため、次のバッチ実行日の午前10時を表示する
      return moment(this.campaign.endDatetime).subtract(1, 'hours').add(1, 'days').format('YYYY年MM月DD日 10:00')
    },

    isCampaignBeforeStart() {
      return this.campaign.status === CAMPAIGN_STATUS.BEFORE_EVENT
    },

    isRepostEntryCampaign() {
      return this.campaign.type === 'keyword' && isRepostEntryActionType(this.campaign.setting?.entryActionType)
    },

    repostCollectionAlertState() {
      return resolveRepostCollectionAlertState({
        type: this.campaign.type,
        entryActionType: this.campaign.setting?.entryActionType,
        status: this.campaign.status,
        hasTweetPostUrl: Boolean(this.campaign.hasTweetPostUrl)
      })
    },

    isRepostCampaignBeforeStart() {
      return this.repostCollectionAlertState === RepostCollectionAlertState.BEFORE_START
    },

    isRepostCampaignBeforeCollect() {
      return this.repostCollectionAlertState === RepostCollectionAlertState.BEFORE_COLLECTION
    },

    isCampaignBeforeCollect() {
      return (
        ['tweet', 'tweet_media'].includes(this.campaign.setting?.entryActionType) &&
        this.campaign.status === CAMPAIGN_STATUS.BEFORE_COLLECTION
      )
    },

    isCampaignFinalCollection() {
      return this.campaign.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION
    },

    isCampaignCollectionCompleted() {
      return this.campaign.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED
    }
  },
  async mounted() {
    const params = {
      campaignId: this.$route.params.campaignId
    }

    await this.setParams(params)

    await this.fetchCampaign()

    if (this.isLeave || !this.campaign || !this.campaign.id) {
      return
    }

    if (this.currentGroupId !== this.campaign.groupId) {
      this.setCurrentGroup(this.campaign.groupId)
    }

    this.setBreadcrumb([
      {
        name: 'キャンペーン一覧',
        link: '/campaigns'
      },
      {
        name: this.campaign.title,
        link: null,
        iconName: this.campaign.account ? this.campaign.account.name : '削除されたアカウント',
        iconUrl: this.campaign.account ? this.campaign.account.pictureUrl : null,
        iconType: this.campaign.snsType,
        label: this.campaign.type === 'instantwin' ? 'インスタントウィン' : null,
        isIcon: true
      }
    ])
  },
  watch: {
    params() {
      this.fetchPrizes()
    }
  },
  methods: {
    formatNumber,

    ...mapActions(useSystemStore, ['setCurrentGroup']),
    ...mapActions(useTwitterCampaignPrizeStore, ['fetchPrizes', 'setParams', 'fetchCampaign', 'reset']),
    ...mapActions(useNavbarStore, ['setBreadcrumb']),

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      TrackingService.sendEvent('click:応募グループ一覧（X）|CSVダウンロード')

      const params = Object.assign({}, this.params, {
        forCsv: 1
      })
      const result = await api.get('/twitter_campaign_prizes', {
        params
      })

      if (!result.data) {
        return {
          error: 'ERROR_LOADING'
        }
      }

      const prizes = result.data.prizes
      const filename = `campaign_prize_${this.campaign.title}_applicants_${moment().format('YYYY_MM_DD')}`
      const csvData = []
      csvData.push([
        '応募グループ名',
        '応募キーワード',
        ...(this.campaign.type === 'old_web_instantwin' ? ['開始日時', '終了日時'] : []),
        '応募者数',
        '当選者数',
        '当選者数(残り)',
        '推定リーチ'
      ])

      // CSVデータを格納
      prizes.forEach(prize => {
        csvData.push([
          prize.name,
          prize.entryKeyword,
          ...(this.campaign.type === 'old_web_instantwin'
            ? [formatDatetime(prize.startDatetime), formatDatetime(prize.endDatetime)]
            : []),
          prize.applicantCount,
          prize.winnerCount,
          prize.maxWinnerCount - prize.winnerCount,
          prize.estimatedReachCount
        ])
      })

      return {
        filename,
        data: csvData
      }
    },

    /**
     * ページを変更イベント
     * @param {number} page ページ
     */
    onChangePagingNo(page: number) {
      if (this.params.pagingNo === page) {
        return
      }
      this.setParams({ pagingNo: page })
      util.scrollToTop()
    },

    /**
     * リミット数を変更イベント
     * @param {number} limitCount リミット数
     */
    onChangeLimitCount(limitCount: number) {
      if (this.params.limitCount === limitCount) {
        return
      }
      this.setParams({ limitCount })
    },

    /**
     * ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onChangeSortBy(sortBy: string) {
      if (this.params.sortBy === sortBy) {
        return
      }
      this.setParams({ sortBy })
    },

    onChangeBackEvent() {
      // 保存されたクエリパラメータがあれば復元、なければそのまま
      const query = this.lastQueryParams || {}
      this.$router.push({ path: '/campaigns', query })

      TrackingService.sendEvent('click:応募グループ一覧（X）|戻る')
    },

    onChangeCampaignPrizeDialogEvent() {
      this.$refs.campaignPrizeDialog.open(this.campaign.id)

      TrackingService.sendEvent('click:応募グループ一覧（X）|応募グループの新規作成')
    },

    onChangeTwitterPostEvent() {
      this.$router.push({ name: 'twitter_posts', params: { campaignId: this.campaign.id } })

      TrackingService.sendEvent('click:応募グループ一覧（X）|応募履歴')
    }
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    this.isLeave = true
    next()
  }
})
</script>
